import React from "react"
import { injectIntl } from "react-intl"
import {
    Link,
} from "react-router-dom"
import Icon from "../../../common/icon/icon.component"
import Contact from "../../../state/contact/models/contact"

type OwnProps = {
    contact : Contact,
}


const ContactLink = (props : OwnProps) => {
    return   <h4 className={"m-0 mt-1"}>
        <strong> {props.contact.getType() === "suppliers" ?
            <Link to={"/suppliers/" + props.contact.getId() + "/details"}>
                {props.contact.getName()}
            </Link> :
            <Link to={"/contacts/" + props.contact.getId() + "/details"}>
                {props.contact.getName()}
            </Link>
        }
        </strong>
        {props.contact.getType() === "persons" && props.contact.getCompanyId() &&
            <small className={"ml-2"}>
                <small>
                    <Link to={"/contacts/" + props.contact.getCompanyId() + "/details"}>
                        <Icon value={"building"}/> {props.contact.getCompanyName()}
                    </Link>
                </small>
            </small>}
    </h4>
}

export default injectIntl(ContactLink)


// WEBPACK FOOTER //
// ./src/quote/project/component/ContactLink.tsx